import { Input, Typography } from "antd";
import Errors from "components/Errors";
import { Form } from "react-bootstrap";
import { Controller } from "react-hook-form";

const IngresoToken = ({ control, errors }) => {
  return (
    <div>
      <Controller
        name="datos"
        control={control}
        defaultValue=""
        rules={{ required: "Ingrese su codigo" }}
        render={({ field }) => (
          <Form.Group>
            <Form.Label>Ingresar token</Form.Label>
            <Form.Control {...field} />
          </Form.Group>
        )}
      />

      <br />
    </div>
  );
};

export default IngresoToken;
